module.exports = __webpack_public_path__ + "img/home_icon_science@2x.719a529b.png";